<template>
    <div></div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "logout",
    async mounted() {
        if (this.is_logged_in) await this.logOutCurrentUser(true);
        else await this.$router.push({ name: "login" });
    },
    methods: {
        ...mapActions(["logOutCurrentUser"])
    },
    computed: {
        ...mapState(["is_logged_in", "user"])
    }
};
</script>

<style scoped></style>
